module.exports = __webpack_public_path__ + "img/01.ded14b85.jpg";